import React, { useEffect, useRef } from 'react';
import * as Styles from './styles';
/**
 * Componente TabPanel do Design System OLX
 * O TabPanel é utilizado em conjunto com os componentes Tabs e Tab. Ele é passado como children do componente Tab para renderizar o seu conteúdo associado. Ele compõe a estrutura de renderização do componente Tabs que cuida internamente do necessário para o correto funcionamento do conjunto.
 */
export const TabPanel = _ref => {
  let {
    id,
    children,
    selected
  } = _ref;
  const tabPanelRef = useRef(null);
  useEffect(() => {
    var _a;
    const allLinks = (_a = tabPanelRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a');
    if (!selected) {
      return allLinks === null || allLinks === void 0 ? void 0 : allLinks.forEach(link => link.setAttribute('tabindex', '-1'));
    }
    return allLinks === null || allLinks === void 0 ? void 0 : allLinks.forEach(link => link.setAttribute('tabindex', '0'));
  }, [selected]);
  return React.createElement(Styles.TabPanel, {
    "data-ds-component": "DS-TabPanel",
    id: "panel-".concat(id),
    role: "tabpanel",
    "aria-labelledby": id,
    className: selected ? 'selected' : '',
    "aria-hidden": !selected,
    ref: tabPanelRef
  }, children);
};
TabPanel.displayName = 'TabPanel';